var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { LoadingButton } from '@one-thd/sui-atomic-components';
import { Printer } from '@one-thd/sui-icons';
import React, { useState } from 'react';
import { ExportPurchaseHistory } from '../../../api/oms/order-history';
import { pushPurchaseHistoryHeaderButtonEvent, setPrintHistoryError, } from '../../../utils/purchase-history/analytics';
var generateDefaultFileName = function () {
    var _a, _b;
    var dateTime = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    }).format(new Date());
    var _c = dateTime ? dateTime.split('at') : ['', ''], date = _c[0], time = _c[1];
    var formattedDate = (_a = date === null || date === void 0 ? void 0 : date.slice(0, -1)) === null || _a === void 0 ? void 0 : _a.replace(/[\s,]+/g, '-');
    var formattedTime = (_b = time === null || time === void 0 ? void 0 : time.slice(1)) === null || _b === void 0 ? void 0 : _b.replace(' ', '-').replace(':', '-');
    return "Purchase_History_".concat(formattedDate, "_").concat(formattedTime, ".pdf");
};
export var PrintButton = function (_a) {
    var _b = _a.orderHistory, _c = _b.customerAccountId, customerAccountId = _c === void 0 ? '' : _c, endDate = _b.endDate, pageNumber = _b.pageNumber, pageSize = _b.pageSize, _d = _b.resultsFilter, resultsFilter = _d === void 0 ? '' : _d, searchBy = _b.searchBy, _e = _b.searchType, searchType = _e === void 0 ? 'ORDERS' : _e, _f = _b.sortBy, sortBy = _f === void 0 ? '' : _f, _g = _b.sortOrder, sortOrder = _g === void 0 ? 'asc' : _g, startDate = _b.startDate, setAlertState = _a.setAlertState;
    var _h = useState(false), loading = _h[0], setLoading = _h[1];
    var closeAlert = function () {
        if (setAlertState)
            setAlertState(null);
    };
    var printClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request, response, blob, fileName, anchor_1, url, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    setLoading(true);
                    request = {
                        orderHistoryRequest: {
                            customerAccountId: customerAccountId,
                            resultsFilter: resultsFilter,
                            searchBy: searchBy,
                            searchType: searchType,
                            sortBy: sortBy,
                            sortOrder: sortOrder,
                            pageSize: pageSize,
                            pageNumber: pageNumber,
                            startDate: startDate,
                            endDate: endDate,
                            exportType: 'pdf',
                        },
                    };
                    pushPurchaseHistoryHeaderButtonEvent('print history');
                    if (!request.orderHistoryRequest.customerAccountId) return [3 /*break*/, 2];
                    return [4 /*yield*/, ExportPurchaseHistory(request)];
                case 1:
                    response = _a.sent();
                    if (response.data) {
                        blob = new Blob([response.data], {
                            type: 'data:application/pdf,',
                        });
                        fileName = generateDefaultFileName();
                        anchor_1 = document.createElement('a');
                        document.body.appendChild(anchor_1);
                        anchor_1.setAttribute('style', 'display: none');
                        url = (window.URL || window.webkitURL).createObjectURL(blob);
                        anchor_1.href = url;
                        anchor_1.download = fileName;
                        anchor_1.click();
                        setTimeout(function () {
                            anchor_1.remove();
                        }, 500);
                        setAlertState({
                            alertMessage: 'Purchase History Data successfully exported. Please check your browser downloads folder for the file.',
                            status: 'success',
                            onClose: closeAlert,
                        });
                        return [2 /*return*/];
                    }
                    setAlertState({
                        alertMessage: 'Something went wrong. Please refresh the page and try again.',
                        status: 'error',
                    });
                    _a.label = 2;
                case 2: return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    setAlertState({
                        alertMessage: 'Something went wrong. Please refresh the page and try again.',
                        status: 'error',
                    });
                    setPrintHistoryError(error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(LoadingButton, { "data-testid": "print-button", loading: loading, variant: "ghost", startIcon: Printer, onClick: printClick }, "Print")));
};
